
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../Dashboard/_services/users.service';
import { AlertService } from '../../Dashboard/_services/alert.service';

// Enforces the same rule the sidebar/profile-menu links already use to
// decide whether to show System Settings (userrole == 'ADMIN', or the
// S-ADMIN super-admin role). Hiding a link never actually stops direct URL
// navigation - authGuard alone only checks "is logged in", so a SALES or
// SALEADMIN account (both of which can log into the back office) could
// still reach /settings by URL without this.
export const adminGuard = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  const userInfo = userService.isLoggedIn();
  const roles = (userInfo.userrole ?? '').split(',');
  if (userInfo.isLoggedIn && (roles.includes('ADMIN') || roles.includes('S-ADMIN'))) {
    return true;
  }
  alertService.alert('You do not have permission to access this page', 'error');
  return router.navigate(['/sales']);
};
